import React from "react";
import logo from "../assets/image 68.png";
import facebookIcon from "../assets/face.png";
import twitterIcon from "../assets/twitter.png";
import linkedinIcon from "../assets/linked.png";
import instagramIcon from "../assets/insta.png";
import styles from "../styles/Footer.module.css";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.footerContainer}>
      {/* 1. About Section: Logo, Description, Social Icons */}
      <div className={styles.aboutSection}>
        <img
          src={logo}
          alt="Arifpay"
          className={styles.logo}
          onClick={() => navigate("/")}
        />
        <p className={styles.description}>
          Arifpay is a leading fintech in Ethiopia. We simplify the path to financial freedom with payment APIs, POS, QR, and merchant tools that help you manage, grow, and protect your business with ease.
        </p>
        <div className={styles.socialIcons}>
          <a href="https://www.facebook.com/ArifpayET" target="_blank" rel="noopener noreferrer">
            <img src={facebookIcon} alt="Facebook" />
          </a>
          <a href="https://twitter.com/ArifpayEthiopia" target="_blank" rel="noopener noreferrer">
            <img src={twitterIcon} alt="Twitter" />
          </a>
          <a href="https://et.linkedin.com/company/arifpay-financial-technologies-s-c" target="_blank" rel="noopener noreferrer">
            <img src={linkedinIcon} alt="LinkedIn" />
          </a>
          <a href="https://www.instagram.com/arifpayet/" target="_blank" rel="noopener noreferrer">
            <img src={instagramIcon} alt="Instagram" />
          </a>
        </div>
      </div>

      {/* 2. Newsletter Subscription Section (Text only on mobile, with input on desktop) */}
      <div className={styles.newsletterSection}>
        <h4>Subscribe to our newsletter</h4>
        {/* inputWrapper will be hidden on mobile via CSS */}
        <div className={styles.inputWrapper}>
          <input type="email" placeholder="Email address" />
          <button>&gt;</button>
        </div>
      </div>
<div className={styles.linksWrapper}></div>
      {/* 3. Navigation Section (Updated content as per Screenshot (43).png) */}
      <div className={styles.navigationSection}>
        <h4>Navigation</h4>
        <ul>
          <li><a href="/AboutUs">About Us</a></li>
          <li><a href="/Events">Events</a></li>
          <li><a href="/PressRelease">Press Release</a></li>
          <li><a href="/Partners">Partners</a></li>
          <li><a href="/Pricing">Pricing</a></li>
          <li><a href="/Compliance">Compliance</a></li>
        </ul>
      </div>



      {/* 5. Contact Info Section (Updated content as per Screenshot (43).png) */}
      <div className={styles.contactSection}>
        <h4>Contact</h4>
        <p>9395</p>
        <p>info@arifpay.net</p>
        <p>Warka Tower, 3rd Floor</p>
        <p>Bole Sub City, Namibia Street</p>
        <p>Addis Ababa, Ethiopia</p>
      </div>

            {/* 4. Legal/License Section (Privacy Policy, Copyright as per Screenshot (43).png) */}
      {/* This section will be hidden on desktop as it doesn't appear as a separate column in Screenshot (42).png. */}
      <div className={styles.legalSection}>
        {/* On mobile, this will appear. On desktop, it's typically integrated or not shown as a top-level section. */}
        {/* Placeholder h4 to maintain vertical alignment if other sections have headings */}
        <h4>&nbsp;</h4> 
        <ul>
          {/* <li><a href="/Compliance">Compliance</a></li> */}
          <li><a href="#">Privacy Policy</a></li>
          <li><a href="#">Copyright</a></li>
        </ul>
      </div>

      {/* 6. Copyright Statement (Always at the very bottom, full width) */}
      <div className={styles.copyRight}>
        &copy; Copyright Arifpay Financial Technologies Share Company All Rights Reserved.
      </div>
    </div>
  );
};

export default Footer;